function onloadYandexCaptcha(items) {
	if (!window.smartCaptcha) {
		return;
	}

	items = items || document.querySelectorAll('.smart-captcha');
	items.forEach((el) => {
		let widgetId = window.smartCaptcha.render(el, {
			sitekey: el.dataset.sitekey,
			hl: 'ru',
			callback: (token) => {
				el.dataset.token = token;

				let event = new CustomEvent('smart-captcha-success', {
					bubbles: true,
					detail: {
						token: token,
						target: el.dataset.captchaTarget || null,
						widgetId: widgetId,
					},
				});

				el.dispatchEvent(event);
			},
		});

		el.removeAttribute('style');
		el.dataset.widgetId = widgetId;
	});
}

function init(container = null) {
	container = container || document;

	let items = container.querySelectorAll('.smart-captcha');
	if (!items.length) {
		return;
	}

	if (document.getElementById('smartcaptcha')) {
		onloadYandexCaptcha(items);
		return;
	}

	let script = document.createElement('script');

	script.setAttribute('src', `https://smartcaptcha.yandexcloud.net/captcha.js`);
	script.setAttribute('id', 'smartcaptcha');
	script.async = true;
	script.defer = true;
	script.onload = () => {
		onloadYandexCaptcha(items)
	};

	document.head.appendChild(script);
}

document.addEventListener('show.bs.modal', (e) => {
	init(e.target);
});

document.addEventListener('DOMContentLoaded', () => init());

typeof onTurboRender !== 'undefined' && onTurboRender(() => init());
